import { persistentMap } from '@nanostores/persistent';

type Params = Record<string, string>;

export interface PageParams {
  Conversion_Entry_Page_Most_Recent?: string;
  UTM_Campaign___Most_Recent?: string;
  utm_campaign?: string;
  UTM_Content___Most_Recent?: string;
  utm_content?: string;
  UTM_Medium___Most_Recent?: string;
  utm_medium?: string;
  UTM_Source___Most_Recent?: string;
  utm_source?: string;
  UTM_Term___Most_Recent?: string;
  utm_term?: string;
  worker_classification_results?: string;
  Worker_Classification_Results?: string;
  worker_classification_score?: string;
  Worker_Classification_Score?: string;
}

interface AnalyticsParams {
  siteEntryPoint: string;
  pageParams: PageParams;
}

export const analyticsParamsStore = persistentMap<AnalyticsParams>(
  'analytics:',
  {
    siteEntryPoint: '',
    pageParams: {},
  },
  {
    encode: (value: string | PageParams) => JSON.stringify(value),
    decode: (value: string) => JSON.parse(value),
  },
);

const getOrganicOrDirectMedium = () =>
  document.referrer === '' ? 'Direct' : `Organic: ${document.referrer}`;

const setPardotKeys = ({
  utm_medium,
  utm_source,
  utm_campaign,
  utm_content,
  utm_term,
  worker_classification_score,
  worker_classification_results,
}: Params) => ({
  UTM_Medium___Most_Recent: utm_medium || getOrganicOrDirectMedium(),
  UTM_Source___Most_Recent: utm_source,
  UTM_Campaign___Most_Recent: utm_campaign,
  UTM_Content___Most_Recent: utm_content,
  UTM_Term___Most_Recent: utm_term,
  Worker_Classification_Score: worker_classification_score,
  Worker_Classification_Results: worker_classification_results,
});

export const getUrlParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const params: Params = {};

  for (const [key, value] of urlParams.entries()) {
    params[key] = value;
  }

  return params;
};

const removeUndefinedParams = (params: Params) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined),
  );

export const storeUrlParams = () => {
  const { host, pathname, search } = window.location;

  const params = getUrlParams();
  const pardotParams = setPardotKeys(params);
  const entryPoint =
    analyticsParamsStore.get().siteEntryPoint || `${host}${pathname}${search}`;
  const storedParams = analyticsParamsStore.get().pageParams;

  analyticsParamsStore.setKey('siteEntryPoint', entryPoint);

  analyticsParamsStore.setKey(
    'pageParams',
    removeUndefinedParams({
      ...storedParams,
      ...pardotParams,
      ...params,
      Conversion_Entry_Page_Most_Recent: entryPoint,
    }),
  );
};
